// extracted by mini-css-extract-plugin
module.exports = {"exerciseBox2":"L2_exerciseBox2__3UQy0","hint":"L2_hint__3mDik","alert":"L2_alert__3nMU7","alertCorrect":"L2_alertCorrect__3cB68"};